console.log("init Proteus treatments -- 1.01")

// HED-02 patch
function activateHED02() {
  console.log("[HED-02] activated");
  function flickityFix() {
    if (!window.Flickity) { setTimeout(flickityFix, 200); return; }
    var section = document.querySelector('[id*="__testimonials_bNTJiJ"]');
    if (!section) { setTimeout(flickityFix, 200); return; }

    ['.TestimonialNav--slider', '.TestimonialList'].forEach(function (sel) {
      var el = section.querySelector(sel);
      if (!el) return;
      var flkty = Flickity.data(el);
      if (!flkty) return;
      flkty.getSize();
      flkty.cells.forEach(function (cell) { cell.getSize(); });
      flkty._positionCells(0);
      flkty._getWrapShiftCells();
      flkty.shiftWrapCells(flkty.x);
      flkty.positionSliderAtSelected();
      flkty.viewport.style.height = flkty.maxCellHeight + 'px';
    });

    var list = section.querySelector('.TestimonialList');
    if (list && Flickity.data(list)) Flickity.data(list).playPlayer();
  }

  setTimeout(flickityFix, 300);
}
// end HED-02

//
// START PP Logic
//

const push_pp_offers = (ref_id = "") => {
  if(window.sessionStorage.getItem("Proteus pp-session-id") && window.cart_pp_offers.length > 0){

    let session_id = window.sessionStorage.getItem("Proteus pp-session-id");

    console.log("push_pp_offers()", ref_id, session_id);

    if(ref_id == ""){
      ref_id = session_id;
    }

    fetch("https://proteus-hedoine.fly.dev/api/pp_offers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        referenceId: ref_id,
        offers: window.cart_pp_offers
      })
    }).then(res => res.json()).then(console.log).catch(console.error);

  }
};

// init
setTimeout(() => {
  push_pp_offers("default");
}, 2500)

waitUntil(() => {
  return typeof window.cart_pp_offers != "undefined" && window.cart_pp_offers.length > 0;
}).then(() => {

  if(!window.sessionStorage.getItem("Proteus pp-session-id")){
    let pp_session_id = "pp-";
    for (let i = 0; i < 16; i++) {
      pp_session_id += Math.floor(Math.random() * 10);
    }
    window.sessionStorage.setItem("Proteus pp-session-id", pp_session_id)
    setTimeout(() => {
      gtm_add_cartAttribute("pp-session-id", pp_session_id);
    }, 2500); // delay to reduce API clogging
  }

  push_pp_offers();

}).catch();

async function get_proteus_product_data(prod_ids) {
  console.log("get_proteus_product_data()");
  // could potentially do this via Shopify REST API
  const response = await fetch(`https://proteus-hedoine.fly.dev/api/catalog?lookup=product_offers&ids=${prod_ids}`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}

document.addEventListener("proteus:cart-changed", async (e) => {

  console.log("proteus: cart updated", e.detail);

  window.cart_data = e.detail;

  // add.js returns a line item instead of full cart
  if (!window.cart_data?.items) {
    try {
      const res = await fetch("/cart.js");
      window.cart_data = await res.json();
    } catch (err) {
      console.error("failed to normalize cart", err);
      return;
    }
  }

  let cart_prod_ids = [];
  for(let i = 0; i < cart_data.items.length; i++){
    cart_prod_ids.push(cart_data.items[i].product_id);
  }

  get_proteus_product_data(cart_prod_ids.toString()).then(response => {
    console.log("get_proteus_product_data", response)
    window.staged_pp_offers = response.offers;
    
    window.cart_pp_offers = [];
    for(let i = 0; i < window.staged_pp_offers.length; i++){

      window.cart_pp_offers.push({

        pp_offer_type: window.staged_pp_offers[i].def_type,
        pp_offer_new_qty: window.staged_pp_offers[i].def_quantity,
        pp_offer_new_interval: window.staged_pp_offers[i].ref_new_interval,
        pp_offer_id: window.staged_pp_offers[i].def_offer_id,
        pp_offer_banner_title: window.staged_pp_offers[i].content_banner_title,
        pp_offer_banner_subtitle: window.staged_pp_offers[i].content_banner_subtitle,
        pp_offer_title: window.staged_pp_offers[i].content_title,
        pp_offer_image_url: window.staged_pp_offers[i].content_images[0],
        pp_offer_description: [window.staged_pp_offers[i].content_description],
        pp_offer_compare_at: window.staged_pp_offers[i].content_compare_at,
        pp_offer_price: window.staged_pp_offers[i].content_offer_price,
        changes: window.staged_pp_offers[i].changes,

      });

    }

    push_pp_offers();
  
  });
});

//
// END PP Logic
//